import { useContext } from "react";
import { hideModal } from "_+_Portal/context/Actions/modal/modal";
import { PortalContext } from "_+_Portal/context/Provider";
import { BodyModal, ContainerModal, TopModal } from "./localStyle";
import {
    Plugins,
  } from "@capacitor/core";

const { App } = Plugins;


const ModalSalir = () => {
    const {
               modalDispatch,
       
      } = useContext(PortalContext);

 const handleSuccess = () => {
    App.exitApp();
    hideModal()(modalDispatch);
 };
 const handleDanger = () => {
    hideModal()(modalDispatch);
 };

  return (
    <ContainerModal>
      <TopModal>
        <span>ATENCIÓN</span>
      </TopModal>
      <BodyModal>
        <span>
        ¿Desea salir de la App?
         
        </span>
        <div className="container-btn">
          <button onClick={handleDanger} className="danger">NO</button>
          <button  onClick={handleSuccess} className="success">SI</button>
        </div>
      </BodyModal>
    </ContainerModal>
  );
};

export default ModalSalir;

// Si desea salir de la aplicación oprima "SI", de lo contrario, oprima
// "NO".